<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span>Đơn vị cung cấp</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form :model="mData.dataForm" :rules="mData.validForm" ref="myForm" label-width="100%" label-position="top">
          <b-row>
            <b-col :md="mData.isTourAgent ? 12 : 8">
              <b-row>
                <b-col md="12">
                  <el-form-item label="Tên công ty lữ hành" prop>
                    <el-input type="text" v-model="mData.dataForm.ten.vi" :disabled="mData.viewMode == 'detail'"
                      clearable></el-input>
                  </el-form-item>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="5">
                  <el-form-item label="Hotline" prop>
                    <el-input type="text" v-model="mData.dataForm.hotline" :disabled="mData.viewMode == 'detail'"
                      clearable></el-input>
                  </el-form-item>
                </b-col>
                <b-col md="7">
                  <el-form-item label="Slogan" prop>
                    <el-input type="text" v-model="mData.dataForm.slogan" :disabled="mData.viewMode == 'detail'"
                      clearable></el-input>
                  </el-form-item>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <el-form-item label="Email" prop>
                    <el-input type="text" v-model="mData.dataForm.email" :disabled="mData.viewMode == 'detail'"
                      clearable></el-input>
                  </el-form-item>
                </b-col>
                <b-col md="6">
                  <el-form-item label="Website" prop>
                    <el-input type="text" v-model="mData.dataForm.website" :disabled="mData.viewMode == 'detail'"
                      clearable></el-input>
                  </el-form-item>
                </b-col>
                <b-col md="6" v-if="!mData.isTourAgent">
                  <el-form-item label="Loại hình ưu đãi" prop="uu_dai.loai_hinh_uu_dai">
                    <el-select v-model="mData.dataForm.uu_dai.loai_hinh_uu_dai" placeholder="Chọn loại hình ưu đãi"
                      clearable @change="changeTypeEndow(mData.dataForm.uu_dai.loai_hinh_uu_dai)">
                      <el-option v-for="item in mData.dataDefault.listLoaiHinhUuDai" :key="item.value"
                        :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </b-col>
                <b-col md="6" v-if="!mData.isTourAgent && mData.dataForm.uu_dai && mData.dataForm.uu_dai.loai_hinh_uu_dai == 'giam_gia_tien'">
                  <el-form-item label="Giá trị ưu đãi" prop="uu_dai.gia_tri_uu_dai">
                    <ElementUiMoney v-model="mData.dataForm.uu_dai.gia_tri_uu_dai" :placeholder="'Nhập giá trị ưu đãi'"
                      :outlined="true" :clearable="true" @input="forceUpdateUI" />
                  </el-form-item>
                </b-col>
                <b-col md="6"
                  v-if="!mData.isTourAgent && mData.dataForm.uu_dai && mData.dataForm.uu_dai.loai_hinh_uu_dai == 'giam_gia_phan_tram'">
                  <el-form-item label="Giá trị ưu đãi (%)" prop="uu_dai.gia_tri_uu_dai">
                    <el-input v-model="mData.dataForm.uu_dai.gia_tri_uu_dai" type="number"
                      placeholder="Nhập giá trị ưu đãi" @change="changeShowInput(mData.dataForm.uu_dai.gia_tri_uu_dai)"
                      @input="forceUpdateUI()"></el-input>
                  </el-form-item>
                </b-col>
              </b-row>
            </b-col>
            <b-col md="4" v-if="!mData.isTourAgent">
              <el-form-item class="mb-3" label="Ảnh đại diện" prop="avatar_id">
                <el-upload action :auto-upload="false" list-type="picture-card"
                  :limit="mData.fileUploadOption.AnhDaiDien.limit" :accept="mData.fileUploadOption.AnhDaiDien.accept"
                  :on-change="fn_uploadChangeAnhDaiDien" :on-preview="fn_uploadPreviewAnhDaiDien"
                  :on-remove="fn_uploadRemoveAnhDaiDien" :on-exceed="fn_uploadExceedAnhDaiDien"
                  :file-list="mData.fileUploadOption.AnhDaiDien.fileList"
                  :disabled="mData.viewMode == 'accept' || mData.viewMode == 'detail'"
                  :class="[mData.fileUploadOption.AnhDaiDien.fileList.length > 0 ? 'hidden-icon-upload' : '']">
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :close-on-click-modal="true" :visible.sync="mData.fileUploadOption.AnhDaiDien.dialogVisible"
                  width="60%" top="51px" title="Chi tiết">
                  <img width="100%" :src="mData.fileUploadOption.AnhDaiDien.dialogImageUrl" alt />
                </el-dialog>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col md="12">
              <b-card>
                <div slot="header">
                  Địa chỉ
                  <div class="card-header-actions">
                    <b-link class="card-header-action btn-minimize" v-b-toggle.collapseDiaChi v-b-tooltip.hover
                      :title="aLang.c_toggle">
                      <i class="icon-arrow-up"></i>
                    </b-link>
                  </div>
                </div>

                <b-collapse id="collapseDiaChi" visible>
                  <b-row>
                    <b-col md="6">
                      <b-row>
                        <b-col md="6">
                          <el-form-item label="Tỉnh/Thành phố" prop>
                            <el-select v-model="mData.dataForm.dia_chi.province_id" :placeholder="aLang.c_select"
                              :disabled="mData.viewMode == 'detail'" clearable filterable>
                              <el-option v-for="item in mData.dataDefault.listProvince" :key="item.id"
                                :label="item.name" :value="item.id"></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                        <b-col md="6" v-if="!mData.isTourAgent">
                          <el-form-item label="Xã/Phường/Thị trấn" prop>
                            <el-select v-model="mData.dataForm.dia_chi.commune_id" :placeholder="aLang.c_select"
                              :disabled="mData.viewMode == 'detail'" clearable filterable>
                              <el-option v-for="item in mData.dataDefault.listCommune" :key="item.id"
                                :label="item.name" :value="item.id"></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                        <b-col md="12">
                          <el-form-item label="Địa chỉ" prop>
                            <el-input type="text" v-model="mData.dataForm.dia_chi.dia_chi"
                              :disabled="mData.viewMode == 'detail'" clearable></el-input>
                          </el-form-item>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col md="6">
                      <b-row>
                        <b-col>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-collapse>
              </b-card>
            </b-col>
          </b-row>
          <!-- <b-row>
            <b-col class="text-center mb-2">
              <el-button
                type="info"
                plain
                @click="fn_handle('update', mData.dataForm.id, mData.dataForm)"
                v-ladda
                >Cập nhật thông tin đơn vị</el-button
              >
            </b-col>
          </b-row> -->
          <b-row class="mt-2">
            <b-col md="12">
              <b-card>
                <div slot="header">
                  Giấy phép kinh doanh
                  <div class="card-header-actions">
                    <b-link class="card-header-action btn-minimize" v-b-toggle.collapseNguoiDaiDien v-b-tooltip.hover
                      :title="aLang.c_toggle">
                      <i class="icon-arrow-up"></i>
                    </b-link>
                  </div>
                </div>

                <b-collapse id="collapseGiayPhepKinhDoanh" visible>
                  <b-row>
                    <b-col md="3">
                      <el-form-item label="Số giấy phép" prop>
                        <el-input type="text" v-model="mData.dataForm.giay_phep_kinh_doanh.so_giay_phep"
                          :disabled="mData.viewMode == 'detail'" clearable></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item label="Nơi cấp" prop>
                        <el-input type="text" v-model="mData.dataForm.giay_phep_kinh_doanh.noi_cap"
                          :disabled="mData.viewMode == 'detail'" clearable></el-input>
                      </el-form-item>
                    </b-col>
                  </b-row>
                </b-collapse>
              </b-card>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12" class="text-center">
              <el-button v-if="!mData.isTourAgent" type="info" plain @click="fn_UpdateChietKhau()" v-ladda>{{ aLang.c_update }}</el-button>

              <el-button @click="fn_go()" type="info" plain>{{ aLang.c_back }}</el-button>
            </b-col>
          </b-row>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import ExtensionService from "../../../service/ExtensionService";
import ValidService from '@/service/ValidService';
import CongTyLuHanhModel from "./CongTyLuHanhModel";
import CongTyLuHanhApi from "../../../moduleApi/CongTyLuHanhApi";
import MapComponent from "../../../component/MapComponent";
import TvCongTyLuHanhApi from '../../../moduleApi/TvCongTyLuHanhApi';
import MapboxComponent from "../../../component/MapboxComponent";
import ElementUiMoney from '@/component/ElementUiMoney';
import mushroomTrangVang from "@/service/api/trangvang-api";
import mushroomDulich from "@/service/api/dulich-api";
import { Filter } from "mushroomjs";

export default {
  components: {
    MapComponent,
    MapboxComponent,
    ElementUiMoney
  },
  data() {
    return {
      checked: false,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "detail",
        isTourAgent: MethodService.checkRole("TourAgent"),
        moduleName: "ThongTinCongTyLuHanh", //requied
        urlImg: ExtensionService.urlSurveyImg,
        tableRules: MethodService.copyObject(CongTyLuHanhModel.tableRules),
        dataDefault: {
          roles: DataService.roles,
          showMap: false,
          listGioiTinh: DataService.gioiTinh,
          listCountry: [],
          listProvince: [],
          listDistrict: [],
          listCommune: [],
          listLoaiHinhUuDai: [
            {
              value: "giam_gia_tien",
              label: "Giảm giá tiền"
            },
            {
              value: "giam_gia_phan_tram",
              label: "Giảm giá phần trăm"
            }
          ],
        },
        dataForm: MethodService.copyObject(CongTyLuHanhModel.dataForm),
        validForm: {
          uu_dai: {
            gia_tri_uu_dai: [ValidService.required],
            loai_hinh_uu_dai: [ValidService.requiredChange]
          }
        },
        fileUploadOption: MethodService.copyObject(
          CongTyLuHanhModel.dataFormOther.fileUploadOption
        ),
      },
    };
  },

  methods: {
    forceUpdateUI() {
      this.$forceUpdate();
    },
    changeShowInput(data) {
      if (!data) return
      if (parseInt(data) > 100) this.mData.dataForm.uu_dai.gia_tri_uu_dai = '100'
    },
    fn_go() {
      this.$router.go(-1);
    },
    fn_UpdateChietKhau() {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          let data = {
            id: this.mData.dataForm.id,
            loai_hinh_uu_dai: this.mData.dataForm.uu_dai.loai_hinh_uu_dai,
            gia_tri_uu_dai: parseInt(this.mData.dataForm.uu_dai.gia_tri_uu_dai)
          }
          try {
            await TvCongTyLuHanhApi.updateHdvUuDai(data);
            this.fn_initTable();
          } catch (error) {
            console.info("error", error);
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    validatePercent(rule, value, callback) {
      if (value > 100) {
        callback(new Error("Phần trăm không quá 100%"))
      } else {
        callback()
      }
    },
    changeTypeEndow(type) {
      if (type == "giam_gia_phan_tram") {
        this.mData.validForm.gia_tri_uu_dai = [
          ValidService.required,
          {
            validator: this.validatePercent,
            trigger: "blur"
          }
        ]
      } else {
        this.mData.validForm.gia_tri_uu_dai = [ValidService.required]
      }
      this.mData.dataForm.uu_dai.gia_tri_uu_dai = undefined;
    },
    //get list table
    async fn_initTable() {
      let currentUser = MethodService.getCurrentUser();
      let dataFilter = {
        filters: "nguoi_quan_ly_ids=" + currentUser.id,
      };

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }
      if (this.mData.tableRules.showUrl) {
        this.$router.replace({
          name: "Admin-" + this.mData.moduleName + "-detail"
        }).catch(() => { });
      }
      let res = await CongTyLuHanhApi.list(dataFilter);
      if (res.result && res.result.length > 0) {
        let resDiaChi = {};
        let resGiayPhep = {};
        let resTen = {};
        if (res.result[0].ten &&
          res.result[0].ten != null) {
          resTen = MethodService.checkDifferentObject(
            MethodService.copyObject(
              CongTyLuHanhModel.dataForm.ten
            ),
            res.result[0].ten
          );
        } else {
          resTen = MethodService.copyObject(
            CongTyLuHanhModel.dataForm.ten
          );
        }

        this.mData.dataForm.ten = resTen;

        if (
          res.result[0].dia_chi &&
          res.result[0].dia_chi.province_id
        ) {
          let provinceId = res.result[0].dia_chi.province_id;

          // Lấy thông tin tỉnh/thành phố qua mushroomjs (trangvang-api)
          let resProvince = await mushroomTrangVang.province.findByIdAsync({
            id: provinceId,
          });
          this.mData.dataDefault.listProvince = resProvince.result
            ? [resProvince.result]
            : [];

          // Lấy danh sách xã/phường từ api dulich communes, lọc theo provinceId
          let resCommune = await mushroomDulich.commune.getAllAsync({
            filters: Filter.eq("provinceId", provinceId).build(),
          });
          this.mData.dataDefault.listCommune = resCommune.result || [];
        }

        if (
          res.result[0].dia_chi &&
          res.result[0].dia_chi != null
        ) {
          resDiaChi = MethodService.checkDifferentObject(
            MethodService.copyObject(CongTyLuHanhModel.dataForm.dia_chi),
            res.result[0].dia_chi
          );
        } else {
          resDiaChi = MethodService.copyObject(
            CongTyLuHanhModel.dataForm.dia_chi
          );
        }

        this.mData.dataForm.dia_chi = resDiaChi;

        if (
          res.result[0].giay_phep_kinh_doanh &&
          res.result[0].giay_phep_kinh_doanh.so_giay_phep != null
        ) {
          resGiayPhep = MethodService.checkDifferentObject(
            MethodService.copyObject(
              CongTyLuHanhModel.dataForm.giay_phep_kinh_doanh
            ),
            res.result[0].giay_phep_kinh_doanh
          );
        } else {
          resGiayPhep = MethodService.copyObject(
            CongTyLuHanhModel.dataForm.giay_phep_kinh_doanh
          );
        }
        const tvConTyLuHanhApiRes = await TvCongTyLuHanhApi.findById(res.result[0].id);
        if (tvConTyLuHanhApiRes.result) {
          if (
            tvConTyLuHanhApiRes.result.huong_dan_vien &&
            tvConTyLuHanhApiRes.result.huong_dan_vien.uu_dai &&
            (tvConTyLuHanhApiRes.result.huong_dan_vien.uu_dai.loai_hinh_uu_dai || tvConTyLuHanhApiRes.result.huong_dan_vien.uu_dai.gia_tri_uu_dai)
          ) {
            this.mData.dataForm.uu_dai = {
              loai_hinh_uu_dai: tvConTyLuHanhApiRes.result.huong_dan_vien.uu_dai.loai_hinh_uu_dai,
              gia_tri_uu_dai: tvConTyLuHanhApiRes.result.huong_dan_vien.uu_dai.gia_tri_uu_dai
            }
          }
        }
        this.mData.dataForm.id = res.result[0].id;
        this.mData.dataForm.giay_phep_kinh_doanh = resGiayPhep;
        this.mData.dataForm.hotline = res.result[0].hotline;
        this.mData.dataForm.email = res.result[0].email;
        this.mData.dataForm.dien_thoai = res.result[0].dien_thoai;
        this.mData.dataForm.website = res.result[0].website;
        this.mData.dataForm.slogan = res.result[0].slogan;
      }
    },

    //upload ảnh
    fn_uploadCheckFileSize(file) {
      return MethodService.checkFileSize(file, 3);
    },

    fn_uploadRemoveAnhDaiDien() {
      this.mData.dataForm.avatar_id = null;
      this.mData.fileUploadOption.AnhDaiDien.fileList = [];
    },
    fn_uploadChangeAnhDaiDien(file, fileList) {
      ExtensionService.upload(file, "anhDaiDien")
        .then((res) => {
          this.mData.dataForm.avatar_id = res.result;
          this.mData.fileUploadOption.AnhDaiDien.fileList = fileList;
        })
        .catch(() => {
          fileList.forEach((el, i) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadExceedAnhDaiDien() {
      window.toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.AnhDaiDien.limit} file`
      );
    },
    fn_uploadPreviewAnhDaiDien(file) {
      this.mData.fileUploadOption.AnhDaiDien.dialogImageUrl = file.url;
      this.mData.fileUploadOption.AnhDaiDien.dialogVisible = true;
    },

    fn_uploadRemoveAnhGiayTo(file, fileList) {
      let data = fileList.map(el => el.id);
      this.mData.dataForm.giay_to.scan = data;
    },
    fn_uploadChangeAnhGiayTo(file, fileList) {
      ExtensionService.upload(file, "anhScan")
        .then((res) => {
          this.mData.dataForm.giay_to.scan.push(res.result);
          fileList.forEach((el) => {
            if (el.uid == file.uid) {
              el.id = res.result;
            }
          });
          this.mData.fileUploadOption.AnhGiayTo.fileList = fileList;
        })
        .catch(() => {
          fileList.forEach((el, i) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadExceedAnhGiayTo() {
      window.toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.AnhGiayTo.limit} file`
      );
    },
    fn_uploadPreviewAnhGiayTo(file) {
      this.mData.fileUploadOption.AnhGiayTo.dialogImageUrl = file.url;
      this.mData.fileUploadOption.AnhGiayTo.dialogVisible = true;
    },

    fn_addLatLngDiaDiem(lat, lng) {
      this.mData.dataForm.dia_chi.vi_do = lat;
      this.mData.dataForm.dia_chi.kinh_do = lng;
    },

    fn_getDataFromMapboxComponent(value) {
      this.mData.mapDataObject = value;
    },

    //click button
    fn_handle(type, scope, row) {
      if (type == "create") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-create",
        });
      }
      if (type == "update") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-update",
          params: { id: row.id },
        });
      }
      if (type == "detail") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-detail",
          params: { id: row.id },
        });
      }
    },

    //event table

    fn_formatterDate(row, column, cellValue) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue) {
      return MethodService.formatDate(cellValue, "datetime");
    },

    fn_formatterRoles(row, column, cellValue) {
      let roles = "";
      cellValue.forEach((item) => {
        for (const element of this.mData.dataDefault.roles) {
          if (item == element.value) {
            item = element.label;
            roles += item + " ,";
          }
        }
      });
      roles = roles.slice(0, -1);
      return roles;
    },

    async fn_initDataDefault() { },

    fn_download(file) {
      window.open(ExtensionService.urlSurveyFile + file.id);
    },
  },

  created() {
    this.fn_initDataDefault();
  },
  mounted() {
    this.fn_initTable();
  },
};
</script>
<style lang="scss">
::v-deep .el-link {
  display: flex !important;
  justify-content: flex-start !important;
}

::v-deep .el-link--inner {
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.el-message-box {
  width: 95%;

  @media (min-width: 576px) {
    width: 420px;
  }
}
</style>
